import { z } from 'zod';
import { documentResponseSchema } from './document.schema';
import { MAX_FILE_SIZE_BYTES, safeFileNameSchema } from './upload.schema';

/**
 * Anhänge an einem Beleg (Verkauf/Einkauf). Die Dateien liegen als reguläre
 * DMS-Dokumente in einem eigenen Ordner des Belegs (`<Partei>/Belege/<Nummer>`)
 * — dadurch auch im zentralen Dateimanager auffindbar (§6, kein Schatten-Speicher).
 * Zugriff läuft aber über die beleg-eigenen Endpunkte (`sales.*`/`procurement.*`),
 * nicht über die DMS-Endpunkte (`dms.*`).
 */

/** Upload starten — wie DMS, aber ohne `folderId` (der Server leitet ihn aus dem Beleg ab). */
export const belegAttachmentUploadInitSchema = z.object({
  name: safeFileNameSchema,
  mimeType: z.string().trim().min(1).max(255),
  size: z.number().int().min(0).max(MAX_FILE_SIZE_BYTES),
});
export type BelegAttachmentUploadInitInput = z.infer<typeof belegAttachmentUploadInitSchema>;

/** Liste der Anhänge eines Belegs + ob überhaupt ein Dateispeicher konfiguriert ist. */
export const belegAttachmentsResponseSchema = z.object({
  documents: z.array(documentResponseSchema),
  storageConfigured: z.boolean(),
});
export type BelegAttachmentsResponse = z.infer<typeof belegAttachmentsResponseSchema>;

/**
 * Anhang umbenennen (2026-10-15). Fehlt die Endung, hängt der Server die alte
 * an (`keepExtension`) — „Angebot Kunde" wird zu „Angebot Kunde.pdf".
 */
export const renameBelegAttachmentSchema = z.object({
  name: safeFileNameSchema,
});
export type RenameBelegAttachmentInput = z.infer<typeof renameBelegAttachmentSchema>;
